<template>
<!--
<ChartSolidgauge :data="customerCountSourceDataList" :view="[getLanguageStr('crm1','全部客户'),objTool(customerCountSourceData,'sum')]" :sizeClass="'h9x'" class="w10x-min"></ChartSolidgauge>
 -->
<div class="chartRing">
	<div :class="chartClass"></div>
	<!-- <div class="content">
		<span class="cSub">{{view[0]}}</span>
		<div class="value">{{view[1]}}</div>
	</div> -->
</div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {drawSolidgauge} from '@/util/chart.js'
export default{
  name: 'ChartSolidgauge',
  components: {},
  props: {
    ringData: {
      type: Array,
      default: () => { return [] }
    },
    bg: {
      type: String,
      default: '#8080803c'
    },
    color: {
      type: Array,
      default: () => { return [stage.color.list[0], stage.color.list[1]] }
    },
    RingWidth: {
      type: Number,
      default: 8
    },
    chartClass: {// 图表需要的class
      type: String,
      default: ''
    },
    balance: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  watch: {
    ringData (val) {
      this.run()
    }
  },
  methods: {
    run () {
      // $("#"+this.id).addClass(this.chartClass);
      // 去除数组中null undefined
      let result = []
      this.ringData.forEach(d => {
        if (d) {
          result.push(d)
        } else {
          result.push(0)
        }
      })
      // console.log(result);
      let request = {
        width: this.RingWidth, // 环的宽度
        balance: this.balance,
        color: this.color,
        background: this.bg,
        data: result
      }

      result.length && drawSolidgauge($(this.$el).children()[0], request)
    }
  },
  created () {},
  mounted () {
    // trace(this.data)
  }
}
</script>
<style lang="scss" scoped>
.chartRing{position:relative;
	.content{width:100%;margin:{top:-1.4em;};position:absolute;top:50%;left:0;text-align:center;line-height:1.5;}
	// .value{font-size:2em;}
	>*{position:relative;z-index:1;}
}
</style>



// WEBPACK FOOTER //
// src/components/common/chart/ChartSolidgauge.vue